import { useState, useEffect } from 'react';
import { Singleton } from '../../../../core/services/Singleton';
import { ForpoService } from '../../../custom/forpo/components/service/ForpoService';

interface Props {
    idSelector: number;
    onChange: any;
}

export const SelectStoreCategory = ({ idSelector, onChange }: Props) => {

    const service = new ForpoService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        service.getStoreCategoryCatalogPorPropiedad('State', 1, null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
               //console.log("DataAcces", lista);
            }
        );
    }

    return (
        <>
            <label>Categoria de tienda:</label>
            <select className="form-control" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0} key={Singleton.getInstance().getRandomInt()}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (

                            <option key={index} value={item.DataBeanProperties.IDStoreCategory} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}